import { useEffect, useRef, useState } from "react";

export const useScroll = () => {
  const element = useRef<HTMLDivElement>(null);
  const SCROLL_WIDTH = 900;
  const scrollBy = (options: ScrollToOptions) => {
    if (element.current) {
      element.current.scrollBy(options);
      if (options.left) {
        if (options.left > 0) {
          //scrolling from left to right
          if (
            element.current.scrollLeft +
              element.current.offsetWidth +
              SCROLL_WIDTH >=
            element.current.scrollWidth
          ) {
            setShowRightArrow(false);
          }
          setShowLeftArrow(true);
        } else {
          //scrolling from right to left
          if (element.current.scrollLeft - SCROLL_WIDTH <= 0) {
            setShowLeftArrow(false);
          }
          setShowRightArrow(true);
        }
      }
    }
  };
  const [showRightArrow, setShowRightArrow] = useState<boolean>(false);
  const [showLeftArrow, setShowLeftArrow] = useState<boolean>(false);

  useEffect(() => {
    if (element.current) {
      setShowRightArrow(
        element.current.scrollWidth > element.current.offsetWidth,
      );
    }
  }, [element]);

  return { element, scrollBy, showRightArrow, showLeftArrow, SCROLL_WIDTH };
};
